import React from 'react'

const DRFType = ({ row }) => {

    const drfType = {
        "1": "One Time",
        "2": "Tranche"
    }
    return (
        <div>
            {drfType?.[row.drf_type] ?? '---'}
        </div>
    )
}

export default DRFType